import { AngularEditorConfig } from '@kolkov/angular-editor';
import { RICHTEXT_EDITOR_CONFIG } from './richtext-editor-config';

/**
 * Creates a unique Angular Editor config instance to prevent toolbar state sharing
 * between multiple editor instances on the same page.
 * 
 * @param prefix - Optional prefix for the editor instance (helps with debugging)
 * @returns A deep cloned AngularEditorConfig instance
 */
export function createEditorConfig(prefix?: string): AngularEditorConfig {
  return JSON.parse(JSON.stringify(RICHTEXT_EDITOR_CONFIG));
}

/**
 * Creates multiple unique Angular Editor config instances
 * 
 * @param count - Number of config instances to create
 * @param prefix - Optional prefix for the editor instances
 * @returns Array of unique AngularEditorConfig instances
 */
export function createEditorConfigs(count: number, prefix?: string): AngularEditorConfig[] {
  return Array.from({ length: count }, (_, i) => createEditorConfig(`${prefix}-${i}`));
}
